import breadcrumbComp from "../../common/breadcrumb-comp";
import AddFavourite from "../../utility/js/addFav.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import Utility from "../../../shared/utility.js";
import shippingService from "@/components/shipping/js/shipping-service";
//import materialMovementService from "./material-movement-service.js";
import commonApiService from "@/components/common/js/common-api-service";
import utility from "../../../shared/utility.js";
export default {
  data() {
    return {
      actionList: [],
      mainPage: "",
      favouriteList: [],
      pageUrl: "",
      subPage: "",
      showAdd: false,
      subPageUrl: "",
      backSlash: true,
      backSlashParent: true,
      showLpn:false,
      showSubmit: false,
      refresh: true,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      sourceLPN: "",
      selectedItems: [],
      soSearchText: "",
      poSearchText: "",
      showDataTable: false,
      enableReason:false,
      reasonList:[],
      submitObj: {
        order_id: "",
        user_id: EncryptUtility.localStorageDecrypt("userID"),
        order_type: "",
        stagingLocation: "",
        destinationLPN: "",
        reason_key: "",
        pickedItems: [],
      },
      lpnRule: [
        (v) => (v || "").length <= 39 || "Max Length of 39 character",
        (v) => !!v || "Field is required",
        (value) =>
          /^[0-9]{1,3}(?:-[0-9]{3})*$/.test(value) ||
          "Enter a correct format: 000-000-000-000",
      ],
      unPickHeaders: [
        { text: "LPN", value: "lpn", class: "primary customwhite--text" },
        {
          text: "Part Number",
          value: "part_num",
          class: "primary customwhite--text",
        },
        { text: "BCN", value: "bcn", class: "primary customwhite--text" },
        {
          text: "Serial No",
          value: "serialno",
          class: "primary customwhite--text",
        },
        { text: "ESN", value: "esn", class: "primary customwhite--text" },
        { text: "ICCID", value: "iccid", class: "primary customwhite--text" },
        { text: "Quantity", value: "qty", class: "primary customwhite--text" },
        {
          text: "Qty to Unpick",
          value: "pickQty",
          class: "primary customwhite--text",
        },
      ],
      unpickList: [],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
  },
  mounted() {},
  methods: {
    //Reset Function
    resetFunction() {},
    //to check if its a number of not
    isNumber(event) {
      let value = Utility.isNumber(event);
      return value;
    },
    //Add or remove Favourite
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
    lpnNumFormat(event, num) {
      console.log("LPN before format ", num);
      this.submitObj.destinationLPN = Utility.formatLPNNumber(event, num);
    },
    async getSearchOrder() {
      let searchObj = {
        userid: this.userId,
        order_no: this.soSearchText ? this.soSearchText : this.poSearchText,
        process_type: this.soSearchText ? "SO" : "PO",
      };
      let responseData = await shippingService.searchUnpickedOrders(
        "post",
        searchObj,
        false
      );
      this.unpickList = responseData;
      if (this.unpickList.length > 0) {
        this.submitObj.order_id = responseData[0].order_id;
        this.showDataTable = true;
        this.unpickList.forEach((item, index) => {
          item.id = index + 1;
          item.defaultPickQty = item.qty;
        });
      } else {
        this.showDataTable = false;
      }
    },
    async onKeydownLocation() {
      let obj = {
        userid: parseInt(this.userId),
        bin: this.submitObj.stagingLocation,
        process_type: this.soSearchText ? "SO" : "PO",
        order_id: this.submitObj.order_id,
       
      };
      let data = await shippingService.postBinValidate(
        "post",
        obj,
        false
      );
      if (data !== undefined) {
        if (data?.Result?.length == 0) {
        Utility.showErrorToast("Staging Location is not valid");
        this.submitObj.stagingLocation = "";
        } else {
          if(data.Result.length>0){
            this.reasonList=data.Result;
            this.enableReason=true;
            this.showLpn=true;
        }
      }
      }
    },
    async getLPNNumber() {
      let lpnData = await commonApiService.getNextAvailableLPN(
        "get",
        this.userId
      );
      if (lpnData.message !== "NA") {
        this.submitObj.destinationLPN = lpnData[0]?.lpn;
        await this.validateLpn();
      }
    },
    onChangeReason(){
      this.showSubmit = true;
    },
    //Reset Function
    async onClickSubmit() {
        this.submitObj.order_type = this.soSearchText ? "SO" : "PO";
        (this.submitObj.pickedItems = this.selectedItems.map((x) => ({
          part_id: x.part_id,
          lpn_id: x.lpn_id,
          bcn: x.bcn,
          serialno: x.serialno,
          esn: x.esn,
          iccid: x.iccid,
          pick_quantity: x.isNonSerialized ? x.defaultPickQty : x.qty,
          isNonSerialized:x.isNonSerialized
        })));
        let final_save = {
          json: JSON.stringify(this.submitObj)
        };
        let response = await shippingService.postSubmitUnpicked(
          "post",
          final_save,
          true
        );
        if(response){
          this.clearForm();
        }
    },
    clearForm() {
      this.submitObj = {
        order_no: "",
        stagingLocation: "",
        destinationLPN: "",
        pickedItems: [],
      };
      this.selectedItems = [];
      this.soSearchText = "";
      this.poSearchText = "";
      this.showDataTable = false;
      this.enableReason=false;
      this.reasonList=[];
      this.showLpn=false;
      this.showSubmit=false;
    },
    async validateLpn() {
      let obj = {
        user_id: parseInt(this.userId),
        it_lpn: "",
        bin: this.submitObj.stagingLocation,
        lpn: this.submitObj.destinationLPN,
      };
      let showMsg = false;
      let data = await shippingService.postValidateLpn(
        "post",
        obj,
        showMsg
      );
      if (data !== undefined) {
        if (data == "Successful") {
          console.log("LPN Validated Successfully");
        }
      }
      else{
        utility.showErrorToast("LPN Validation Failed");
      }
    },
  },
  components: {
    breadcrumbComp,
  },
};
